module.exports = __webpack_public_path__ + "img/home_title1.5b0ecdda.png";